import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCube, faChevronDown, faChevronUp } from '@fortawesome/free-solid-svg-icons';

/**
 * Reusable theme section wrapper used by both the grid view and the list view.
 * Renders the red header bar (with theme name, set count, and collapse toggle)
 * and conditionally renders children when the section is not collapsed.
 */
const ThemeGroup = ({ theme, collapsedThemes, onToggle, className = '', children }) => (
    <div className={`bg-white rounded-xl border border-gray-200 shadow-sm overflow-hidden ${className}`}>
        <div
            className="px-4 sm:px-6 py-3 sm:py-4 bg-gradient-to-r from-red-600 to-red-700 text-white flex justify-between items-center cursor-pointer"
            onClick={() => onToggle(theme.theme_id)}
        >
            <div className="flex items-center">
                <FontAwesomeIcon icon={faCube} className="mr-2 sm:mr-3 text-yellow-400" />
                <h3 className="text-base sm:text-lg font-semibold">{theme.theme_name}</h3>
                <span className="ml-2 sm:ml-3 bg-red-500 text-white text-xs px-2 py-1 rounded-full">
                    {theme.sets.length} {theme.sets.length === 1 ? 'set' : 'sets'}
                </span>
            </div>
            <FontAwesomeIcon
                icon={collapsedThemes[theme.theme_id] ? faChevronDown : faChevronUp}
                className="transition-transform duration-200"
            />
        </div>

        {!collapsedThemes[theme.theme_id] && children}
    </div>
);

export default ThemeGroup;
